import React, { Component } from 'react';

class AuditReportBuilder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auditReport: [
        { id: 1, label: 'Collateral Loan #', value: '' },
        { id: 2, label: 'Borrower Last Name', value: '' },
        { id: 3, label: 'Borrower First Name', value: '' },
        { id: 4, label: 'Original Note Included (Y/N)', value: '' },
        {
          id: 5,
          label: 'Bailee Letter Included w/Copy of Note (Y/N/NA)',
          value: ''
        },
        {
          id: 6,
          label: 'Lost Note Affidavit Included w/Copy of Note (Y/N/NA)',
          value: ''
        },
        { id: 7, label: 'Original Mortgage Included (Y/N)', value: '' },
        {
          id: 8,
          label: 'County Cert. Copy of Mortgage Included (Y/N/NA)',
          value: ''
        },
        { id: 9, label: 'Original Title Policy Included (Y/N)', value: '' },
        { id: 10, label: 'Copy of Title Policy Included (Y/N/NA)', value: '' },
        { id: 11, label: 'Comments', value: '' }
      ]
    };
    this.saveAuditReport = props.saveAuditReport;
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.addItem = this.addItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
  }

  handleChange(event) {
    const { name, value } = event.target;
    const [prop, id] = name.split('-');
    this.setState({
      auditReport: this.state.auditReport.map(item => {
        return item.id === +id
          ? Object.assign({}, item, { [prop]: value })
          : item;
      })
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.saveAuditReport(this.state.auditReport);
  }

  addItem(event) {
    event.preventDefault();
    const newId =
      this.state.auditReport[this.state.auditReport.length - 1].id + 1;
    this.setState({
      auditReport: [
        ...this.state.auditReport,
        { id: newId, label: '', value: '' }
      ]
    });
  }

  removeItem(id) {
    return event => {
      event.preventDefault();
      this.setState({
        auditReport: this.state.auditReport.filter(item => item.id !== id)
      });
    };
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <h2 className="h3 mt-5 mb-4">Submit Audit Report</h2>
        <p className="mb-4">
          Both labels and values are editable. We have populated the audit
          report with some common labels. You can add or remove line items from
          the report. Once the report is complete, click the "Submit Audit
          Report" button at the bottom.
        </p>
        {this.state.auditReport.map(item => (
          <div className="row mb-2" key={item.id}>
            <div className="col">
              <input
                type="text"
                className="form-control"
                placeholder="Label"
                name={`label-${item.id}`}
                value={item.label}
                onChange={this.handleChange}
                required
              />
            </div>
            <div className="col">
              <input
                type="text"
                className="form-control"
                placeholder="Value"
                name={`value-${item.id}`}
                value={item.value}
                onChange={this.handleChange}
                required
              />
            </div>
            <div className="col-auto">
              <button
                className="btn btn-danger"
                onClick={this.removeItem(item.id)}
              >
                &times; Remove
              </button>
            </div>
          </div>
        ))}
        <p className="mb-4">
          <button
            type="button"
            className="btn btn-success btn-sm"
            onClick={this.addItem}
          >
            + Add Line Item
          </button>
        </p>
        <hr className="mb-4" />
        <p className="mb-4">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={this.props.isSaving}
          >
            Submit Audit Report
          </button>
        </p>
      </form>
    );
  }
}

export default AuditReportBuilder;



// WEBPACK FOOTER //
// ./src/components/orders/AuditReportBuilder.js